module.exports = "<div class=\"container\">\n\n  <router-outlet></router-outlet>\n\n</div>\n"